 <div class="container-fluid">
    <div class="row">
        <div class="col-sm-12 col-xl-12">
            <div class="card">
                <div class="card-body">
                    <ng-template #deleteDepartmentContent let-modal>
                        <div class="modal-header">
                            <h4 class="modal-title" id="modal-basic-title">Delete Record</h4>
                            <button type="button" class="btn-close" aria-label="Close"
                                (click)="modal.dismiss('Cross click')"></button>
                        </div>
                        <div class="modal-body">
                            <form class="theme-form">
                                <div class="form-group">
                                    <div class="row justify-content-center align-items-center">
                                        <div class="col-md-12 text-center">
                                            <h4>Delete Confirmation?</h4>
                                            <br />
                                        </div>
                                    </div>
                                    <div class="row justify-content-center align-items-center">
                                        <div class="col-md-3 text-center">
                                            <button class="btn btn-lg btn-outline-danger"
                                                (click)="modal.close('Delete')">Delete</button>
                                        </div>
                                        <div class="col-md-3 text-center">
                                            <button class="btn btn-lg btn-outline-primary"
                                                (click)="modal.dismiss('Cancel')">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                                <!-- Inner form div ROW END -->
                            </form>
                        </div>
                    </ng-template>
                    <div class="row justify-content-end margin-top-bottom-for-add">
                        <div class="col-auto">
                            <button *hasClaim="CLAIMS.ROLES.ADD" class="btn btn-outline-primary" style="margin: 3px;"
                            (click)="redirectToRole()"><i class="fa fa-plus"></i> {{'ADD' | translate}} </button>

                            <!-- <button class="btn btn-outline-danger" style="margin: 3px;"
                                >Delete</button> -->
                        </div>
                    </div>
          
                    <br />
                    <div class="custom-datatable noscroll">
                        <div class="custom-datatable">
                            <table datatable [dtOptions]="dtOptions"  [dtTrigger]="dtTrigger" class="table" id="table1">
                                <thead>
                                    <tr>
                                        <th scope="col">{{ 'CODE' | translate }}</th>
                                        <th scope="col">{{ 'NAME' | translate }}</th>
                                        <th scope="col">{{ 'STATUS' | translate }}</th>
                                        <th scope="col">{{ 'ACTION' | translate }}</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    <tr *ngFor="let role of roles">
                                        <td>{{role.name}}</td>
                                        <td>{{role.name}}</td>
                                        <td title="{{ role.isActive ? ('ACTIVE' | translate) : ('INACTIVE' | translate) }}">
                                            <span class="badge" [ngClass]="role.isActive ? 'badge-success' : 'badge-danger'">
                                                {{ role.isActive ? ('ACTIVE' | translate) : ('INACTIVE' | translate) }}
                                              </span>
                                          </td>
                                        <!-- <td>{{role.isActive ? 'Yes' : 'No'}}</td> -->
                                        <td class="one-line">
                                            <button *hasClaim="CLAIMS.ROLES.DELETE" (click)="deleteModal(deleteDepartmentContent,role)"><i
                                                    class="fa fa-trash" title="Delete"></i></button>
                                            <button *hasClaim="CLAIMS.ROLES.UPDATE" (click)="openForEdit(role)"><i
                                                    class="fa fa-pencil" title="Edit"></i></button>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>

                            <div class="d-flex justify-content-between p-2">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>